import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  
  languageDropdownOpen: boolean = false;

  constructor( private translate: TranslateService) { }

  getDateTranslation(key: string): string {
    let translation = '';
    this.translate.get(key).subscribe((traducao: string) => {
      translation = traducao;
    });
    return translation;
  }  
}
